module.exports = __webpack_public_path__ + "static/media/sort-arrow-not-desc.4e34fb52.svg";